<template>
  <div class="card">
    <div class="card-header">{{ label }}</div>
    <div class="card-body">
      <div class="card-text col-md-12 tw-mb-2">
        <DerToggleWithLabel
          v-model="features[featureId].active"
          :label="label"
        />
      </div>
      <div v-if="features[featureId].active" class="card-text">
        <div
          v-for="(value, key) in features[featureId].config"
          :key="key"
          class="d-flex align-items-center mb-2"
        >
          <label :for="key" class="mb-0 me-2" style="width: 250px">
            {{ formatKey(key) }} <i class="far fa-asterisk" />
          </label>
          <template v-if="hasOptions(key)">
            <select
              v-model="features[featureId].config[key]"
              class="form-control"
              style="width: 420px"
            >
              <option
                v-for="option in getOptions(key)"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </template>
          <template v-else>
            <input
              v-model="features[featureId].config[key]"
              type="text"
              class="form-control"
              style="width: 420px"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DerToggleWithLabel from "../../design-system/DerToggleWithLabel.vue";
import { lang } from "../../i18n";

export default {
  components: { DerToggleWithLabel },
  props: {
    features: Object,
    featureId: [String, Number],
    label: String,
  },
  methods: {
    formatKey(key) {
      key = key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
      const featureName = this.features[this.featureId]?.name?.toLowerCase();
      const translationKeyParent = `feature.${featureName}`;
      const translationKey = `feature.${featureName}.${key}`;
      const translation = lang.get(translationKey);

      // We use dynamic translation keys like 'feature.picsara.department', but if the
      // translation key doesn't exist, the lang library will try 'feature.picsara' instead.
      // To prevent untranslated keys from being shown as 'Picsara', we check if the translation is
      // the same as the parent key translation, and if so, we return the original key instead.
      if (translation === lang.get(translationKeyParent)) {
        return key;
      } else {
        return translation;
      }
    },
    hasOptions(key) {
      const def = this.features[this.featureId].default_config?.[key];
      return def && typeof def === "object" && Array.isArray(def.options);
    },
    getOptions(key) {
      const def = this.features[this.featureId].default_config?.[key];
      return def && typeof def === "object" && Array.isArray(def.options)
        ? def.options
        : [];
    },
  },
};
</script>
